module.exports = global["emailAddresses"] = require("-!./email-addresses.js");